// extracted by mini-css-extract-plugin
module.exports = {"root":"_2zly3","chatRoomList":"_2I_0r","listWrapper":"_10lPO","newChat":"_3HvkZ"};